/**
 * Controls the behavior of the TechDivisionNodeTypesBlogFilterDropdown
 */
export default class TechDivisionNodeTypesBlogFilterDropdown {
    constructor() {
        this.filterDropdownClass = '.js__blog-filter__dropdown'
        this.filterHeaderClass = '.blog-list--filter-header'
        this.blogFilters = document.querySelectorAll('.js-blog-filter')
        this.filterHeaderElements = document.querySelectorAll(this.filterHeaderClass)
        this.resetFilterElement = document.querySelector('.js-reset-filter')
        this.mediaQueryUpLg = window.matchMedia('(min-width: 992px)')
        this.init()
    }

    /**
     * Initializes the interactions
     */
    init() {
        this.addDropdownInteractionListeners()
        this.addResetDropdownsListener()
        this.addWindowResizeListener()
        if (!this.mediaQueryUpLg.matches) {
            // Without the timeout it's not working. I know this is dirty. Don't blame pls.
            setTimeout(this.setAllActiveFilterHeaderLabels, 100)
        }
    }

    /**
     * Add event listeners for dropdown interactions
     */
    addDropdownInteractionListeners() {
        // Toggle filter dropdown
        this.filterHeaderElements.forEach((header) =>
            header.addEventListener('click', () => {
                header.closest(this.filterDropdownClass).classList.toggle('js__open')
            })
        )

        // Dropdown menu interactions
        this.blogFilters.forEach((filter) =>
            filter.addEventListener('click', () => {
                const filterInnerText = filter.innerText
                const dropdownElement = filter.closest(this.filterDropdownClass)
                const replaceTextTargetElement = dropdownElement.querySelector(this.filterHeaderClass)

                // Replace text
                if (filter.classList.contains('active') || filter.dataset.filterBehavior === 'multi-optional') {
                    this.resetDropdownText(replaceTextTargetElement)
                    dropdownElement.classList.remove('js__has-replace-text')
                } else {
                    if (!this.mediaQueryUpLg.matches) {
                        replaceTextTargetElement.innerText = filterInnerText
                        dropdownElement.classList.add('js__has-replace-text')
                    }
                }

                // Close dropdown menu
                dropdownElement.classList.remove('js__open')
            })
        )
    }

    /**
     * Reset the text of the given dropdown
     * @param dropdown
     */
    resetDropdownText(dropdown) {
        dropdown.innerText = dropdown.dataset.conserveLabel
    }

    resetAllFilterHeaders() {
        this.filterHeaderElements.forEach((header) => {
            this.resetDropdownText(header)
            const dropdownElement = header.closest(this.filterDropdownClass)
            dropdownElement.classList.remove('js__has-replace-text')
        })
    }

    /**
     * Add the event listener for the filter reset element
     */
    addResetDropdownsListener() {
        this.resetFilterElement.addEventListener('click', () => {
            this.resetAllFilterHeaders()
        })
    }

    addWindowResizeListener() {
        window.addEventListener('resize', () => {
            if (this.mediaQueryUpLg.matches && document.querySelector('.js__has-replace-text') !== null) {
                this.resetAllFilterHeaders()
            } else if (!this.mediaQueryUpLg.matches && document.querySelector('.js__has-replace-text') === null) {
                this.setAllActiveFilterHeaderLabels()
            }
        })
    }

    setAllActiveFilterHeaderLabels() {
        const activeElements = document.querySelectorAll('.js-blog-filter.active[data-filter-behavior=single-optional]')
        activeElements.forEach((filter) => {
            // Don't use the variables defined in the constructor. With those it does not work on initial page load.
            const dropdownElement = filter.closest('.js__blog-filter__dropdown')
            const replaceTextTargetElement = dropdownElement.querySelector('.blog-list--filter-header')
            replaceTextTargetElement.innerText = filter.innerText
            dropdownElement.classList.add('js__has-replace-text')
        })
    }
}
